import "./style.css";
import TitleSection from "../../Composant/TitleSection/titleSection";
import PORTFOLIODETAILSPROJETCS_JSON from "./detail/portfolio_projects_details.json";
import MediaRessources from "../../ressources/media-ressources";

function PortfolioSection() {
  return (
    <section className="section_portfolio" id="section_portfolio">
      <TitleSection title="Portfolio" progress="75"></TitleSection>

      <div className="boxs-portfolio">
        {PORTFOLIODETAILSPROJETCS_JSON.portfolio_detail.map((card) => (
          <div className="box-portfolio" key={card.id}>
            <a href={"portfolio/" + card.id}>
              <img
                className="img-portfolio"
                src={Object.values(MediaRessources.listImagePortfolio)[card.id]}
                alt={card.alt}
              />
            </a>
            <div className="texte-img-portfolio">{card.titre}</div>
          </div>
        ))}
      </div>

      <div className="link_notion">
        Si vous voulez en savoir plus sur mes expériences professionelles, voici
        un lien vers ma page
        <a href="/experiences" style={{ color: "#8DD1ED" }}>
          {" "}
          expériences
        </a>
      </div>
    </section>
  );
}

export default PortfolioSection;
